var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-overlay",
    {
      attrs: {
        show: _vm.loading && !_vm.noOverlay,
        blur: "1rem",
        opacity: "0.6",
        rounded: "lg",
        variant: "transparent",
      },
    },
    [
      !_vm.custom
        ? _c("b-card", { staticClass: "card-radius" }, [_vm._t("default")], 2)
        : _vm._t("default"),
      !_vm.hideActions
        ? _c("b-card", { staticClass: "card-radius" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center justify-content-between",
              },
              [
                _c(
                  "b-btn",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-center",
                    attrs: {
                      id: "ff-back-btn",
                      disabled: _vm.loading,
                      variant: "secondary",
                    },
                    on: {
                      click: function ($event) {
                        _vm.customBack ? _vm.$emit("back") : _vm.onBackClick()
                      },
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      class: `m${_vm.$dir.rtl ? "l" : "r"}-2`,
                      attrs: {
                        icon: _vm.historyAvailable ? _vm.backIcon : "times",
                      },
                    }),
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.historyAvailable
                              ? _vm.backText
                              : _vm.$t("shared.Close")
                          ) +
                          " "
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _vm._t("actions"),
                    !_vm.hideSubmit
                      ? _c(
                          "b-btn",
                          {
                            staticClass:
                              "mr-4 d-flex align-items-center justify-content-center",
                            attrs: {
                              id: "ff-submit-btn",
                              disabled: _vm.loading || _vm.submitDisabled,
                              variant: "success",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("submit")
                              },
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              class: `m${_vm.$dir.rtl ? "l" : "r"}-2`,
                              attrs: { icon: _vm.submitIcon },
                            }),
                            _c("span", [
                              _vm._v(" " + _vm._s(_vm.submitText) + " "),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }